import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { StorageItemImage } from "@@/shared/storage-items/storage-item-images/storage-item-image";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type AiImageCommandResult = {
    image: StorageItemImage;
};

type AiImageCommand = {
    readonly _id: string;
    readonly _type: "IMAGE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;

    readonly prompt: string;
    readonly model: "dall-e-3" | "dall-e-2";
    readonly numberOfResults: number;
};

type FactoryParams = Except<AiImageCommand, "_id" | "_type" | "_createdAt">;
const aiImageCommandFactory = (params: FactoryParams) => {
    const AiImageCommand: AiImageCommand = {
        ...params,
        _id: generateId({ prefix: "IMAGE_COMMAND__" }),
        _type: "IMAGE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return AiImageCommand;
};

const AiImageCommandZodSchema: z.ZodSchema<AiImageCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("IMAGE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    prompt: z.string(),
    model: z.enum(["dall-e-3", "dall-e-2"]),
    numberOfResults: z.number(),
});

export { aiImageCommandFactory, AiImageCommandZodSchema };
export type {
    AiImageCommand,
    FactoryParams as AiImageCommandFactoryParams,
    AiImageCommandResult,
};
